module.exports = __webpack_public_path__ + "img/icon-answered_calls_day.d6812a06.svg";